import { motion } from 'framer-motion';
import { useLanguage } from '../../i18n/LanguageContext';

export default function HowItWorks() {
  const { t } = useLanguage();
  return (
    <section className="bg-ev-cream py-24 md:py-32 px-6 md:px-10" data-testid="how-it-works-section">
      <div className="max-w-[1300px] mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="font-display font-light text-ev-ink lowercase text-center mb-16 md:mb-20"
          style={{ fontSize: 'clamp(2rem, 5vw, 4rem)', letterSpacing: '-0.03em' }}>
          {t.hw_h}
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {t.hw_steps.map((step, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.12 }}
              className="bg-white rounded-[1.5rem] p-8 md:p-10"
              data-testid={`how-step-${i}`}>
              <span className="font-display text-3xl text-ev-lime-dim">0{i + 1}</span>
              <h3 className="font-display text-2xl text-ev-ink lowercase mt-3 mb-3">{step.title}</h3>
              <p className="font-body text-sm text-ev-gray leading-relaxed">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
